import { lazy } from 'react';

import HideForMobile from '@/components/shared/HideForMobile';
import { UserTypeEnum } from '@/models/User';
import { MaterialChapterRoute, ROUTES } from '@/utils/routes';

const AuthGuard = lazy(() => import('@/components/auth/AuthGuard'));
const TextMaterialEditorPage = lazy(
  () => import('@/pages/course-line/TextMaterialEditorPage'),
);
const TextMaterialPreviewPage = lazy(
  () => import('@/pages/course-line/TextMaterialPreviewPage'),
);

const MATERIAL_CHAPTER_PARAMS: MaterialChapterRoute = {
  courseLineId: ':courseLineId',
  moduleId: ':moduleId',
  slug: ':slug',
  unitId: ':unitId',
  lessonId: ':lessonId',
  bookType: ':bookType',
  bookId: ':bookId',
  chapterId: ':chapterId',
};

const TEXT_MATERIAL_EDITOR_PATTERN = ROUTES.ADMIN.COURSE_LINES.MATERIAL_CHAPTER(
  MATERIAL_CHAPTER_PARAMS,
);

const TEXT_MATERIAL_PREVIEW_PATTERN =
  ROUTES.ADMIN.COURSE_LINES.MATERIAL_PREVIEW_CHAPTER(MATERIAL_CHAPTER_PARAMS);

const CONTENT_ROLES = [UserTypeEnum.SUPER_ADMIN, UserTypeEnum.CONTENT_CREATOR];

export const FOCUS_ROUTES = [
  {
    path: TEXT_MATERIAL_EDITOR_PATTERN,
    element: (
      <AuthGuard roles={CONTENT_ROLES}>
        <HideForMobile>
          <TextMaterialEditorPage />
        </HideForMobile>
      </AuthGuard>
    ),
  },
  {
    path: TEXT_MATERIAL_PREVIEW_PATTERN,
    element: (
      <AuthGuard roles={CONTENT_ROLES}>
        <HideForMobile>
          <TextMaterialPreviewPage />
        </HideForMobile>
      </AuthGuard>
    ),
  },
];

export const FOCUS_PATHS = FOCUS_ROUTES.map(({ path }) => path);
